import { format, set } from "date-fns";

export const formatDuration = (duration: number) =>
  format(set(new Date(0), { seconds: duration }), "mm:ss");
